// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.issueentry-text[data-v-4f4f2757] {
  white-space: pre-wrap;
}
.commentHeader[data-v-4f4f2757] {
  font-size: 1.2em;
}
.issue-group[data-v-4f4f2757] {
  margin-bottom: 20px;
}
.elementSchemaLabel[data-v-4f4f2757] {
  margin: 0;
}
.submissions-comment[data-v-4f4f2757] {
  padding: 10px;
  border-bottom: 1px solid #cccccc;
}
.submissions-comment .comment-text[data-v-4f4f2757] {
  margin: 0;
}
.submissions-comment .help-block[data-v-4f4f2757] {
  white-space: nowrap;
  display: block;
}
.submissions-comment[data-v-4f4f2757]:first-of-type {
  margin-top: 0;
}
`, "",{"version":3,"sources":["webpack://./public/pages/Page/Issues.3.vue","webpack://./../Issues.3.vue"],"names":[],"mappings":"AACA;EACI,qBAAA;ACAJ;ADEA;EACI,gBAAA;ACAJ;ADEA;EACI,mBAAA;ACAJ;ADEA;EACI,SAAA;ACAJ;ADEA;EACI,aAAA;EACA,gCAAA;ACAJ;ADFA;EAIQ,SAAA;ACCR;ADLA;EAOQ,mBAAA;EACA,cAAA;ACCR;ADCI;EACI,aAAA;ACCR","sourcesContent":["\n.issueentry-text {\n    white-space: pre-wrap;\n}\n.commentHeader {\n    font-size: 1.2em;\n}\n.issue-group {\n    margin-bottom: 20px;\n}\n.elementSchemaLabel {\n    margin: 0;\n}\n.submissions-comment {\n    padding: 10px;\n    border-bottom: 1px solid #cccccc;\n    .comment-text {\n        margin: 0;\n    }\n    .help-block {\n        white-space: nowrap;\n        display: block;\n    }\n    &:first-of-type {\n        margin-top: 0;\n    }\n}\n",".issueentry-text {\n  white-space: pre-wrap;\n}\n.commentHeader {\n  font-size: 1.2em;\n}\n.issue-group {\n  margin-bottom: 20px;\n}\n.elementSchemaLabel {\n  margin: 0;\n}\n.submissions-comment {\n  padding: 10px;\n  border-bottom: 1px solid #cccccc;\n}\n.submissions-comment .comment-text {\n  margin: 0;\n}\n.submissions-comment .help-block {\n  white-space: nowrap;\n  display: block;\n}\n.submissions-comment:first-of-type {\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
